import { Items } from 'src/app/core/models/common/items.model';

export enum ColumnIds {
  TRACKING_NUMBER = 'trackingNumber',
  SORT_DATE = 'sortDate',
  SORT_CODE = 'sortCode',
}

export const CONST = {
  SELECT_DATE: $localize`Select Date`,
};

export const ColumnText = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  SORT_DATE: $localize`Sort Date`,
  SORT_CODE: $localize`Sort Code`,
};

export const EXCEL_FILE_NAME = $localize`inbound-scan`;

export type InboundScan = {
  trackingNumber: string;
  sortDate: string;
  sortCode: string;
};

export const SORT_OPTIONS: Items[] = [
  { id: 'D1', selected: true },
  { id: 'D3', selected: true },
  { id: 'D9', selected: true },
  { id: 'L1', selected: true },
  { id: 'P1', selected: true },
  { id: 'P4', selected: true },
  { id: 'P7', selected: true },
  { id: 'S1', selected: true },
  { id: 'S7', selected: true },
];

export const SORT_OPTION_LIST = [...SORT_OPTIONS].map((item) => {
  return {
    label: item.id,
    value: item.id,
  };
});

export const MOCK_TABLE_CONSTS: InboundScan[] = [
  {
    trackingNumber: '1Z2S9JB81263363996',
    sortDate: 'May 2, 2023',
    sortCode: 'L1',
  },
  {
    trackingNumber: '1Z1801790122668888',
    sortDate: 'May 8, 2023',
    sortCode: 'L1',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 3, 2023',
    sortCode: 'D1',
  },
  {
    trackingNumber: '1Z1212121212',
    sortDate: 'May 6, 2023',
    sortCode: 'D3',
  },
  {
    trackingNumber: '1Z987654321',
    sortDate: 'May 6, 2023',
    sortCode: 'D9',
  },
  {
    trackingNumber: '1Z123456789',
    sortDate: 'May 8, 2023',
    sortCode: 'D9',
  },
  {
    trackingNumber: '1Z343434719',
    sortDate: 'May 6, 2023',
    sortCode: 'P1',
  },
  {
    trackingNumber: '1Z937254729',
    sortDate: 'May 10, 2023',
    sortCode: 'P4',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 2, 2023',
    sortCode: 'P4',
  },
  {
    trackingNumber: '1Z343434719',
    sortDate: 'May 9, 2023',
    sortCode: 'P7',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 4, 2023',
    sortCode: 'S1',
  },
  {
    trackingNumber: '1Z123456789',
    sortDate: 'May 5, 2023',
    sortCode: 'S7',
  },
];
